import { Tab } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledTab = styled(Tab)({
  '&.MuiTab-root.Mui-selected': {
    color: 'var(--tab-selected-color)',
  },
  '&.MuiTab-root': {
    color: '#6D7484',
    whiteSpace: 'nowrap',
  },
})
